import React, { useState } from "react";
import { FiUser, FiEdit, FiTrash2, FiPlus, FiSearch } from "react-icons/fi";

const Users = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const [users, setUsers] = useState([
    {
      id: 1,
      name: "John Doe",
      email: "john.doe@example.com",
      role: "User",
      status: "Active",
      lastLogin: "2024-01-15 14:30",
      calls: 45,
    },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane.smith@example.com",
      role: "Admin",
      status: "Active",
      lastLogin: "2024-01-15 13:45",
      calls: 78,
    },
    {
      id: 3,
      name: "Mike Johnson",
      email: "mike.johnson@example.com",
      role: "User",
      status: "Inactive",
      lastLogin: "2024-01-10 09:20",
      calls: 23,
    },
    {
      id: 4,
      name: "Sarah Wilson",
      email: "sarah.wilson@example.com",
      role: "User",
      status: "Active",
      lastLogin: "2024-01-15 12:15",
      calls: 56,
    },
    {
      id: 5,
      name: "David Brown",
      email: "david.brown@example.com",
      role: "Moderator",
      status: "Active",
      lastLogin: "2024-01-15 11:30",
      calls: 34,
    },
  ]);

  const [newUser, setNewUser] = useState({
    name: "",
    email: "",
    role: "User",
    status: "Active",
  });

  const filteredUsers = users.filter(
    (user) =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAddUser = (e) => {
    e.preventDefault();
    const user = {
      ...newUser,
      id: users.length + 1,
      lastLogin: new Date().toLocaleString(),
      calls: 0,
    };
    setUsers([...users, user]);
    setNewUser({ name: "", email: "", role: "User", status: "Active" });
    setShowAddModal(false);
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
  };

  const handleDeleteUser = (userId) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      setUsers(users.filter((user) => user.id !== userId));
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Active":
        return "#27ae60";
      case "Inactive":
        return "#e74c3c";
      default:
        return "#7f8c8d";
    }
  };

  const getRoleColor = (role) => {
    switch (role) {
      case "Admin":
        return "#e74c3c";
      case "Moderator":
        return "#f39c12";
      case "User":
        return "#3498db";
      default:
        return "#7f8c8d";
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "2rem",
        }}
      >
        <h1 style={{ color: "#2c3e50" }}>User Management</h1>
        <button
          className="btn btn-primary"
          onClick={() => setShowAddModal(true)}
        >
          <FiPlus style={{ marginRight: "0.5rem" }} />
          Add User
        </button>
      </div>

      {/* Search Bar */}
      <div style={{ marginBottom: "2rem" }}>
        <div style={{ position: "relative", maxWidth: "400px" }}>
          <FiSearch
            style={{
              position: "absolute",
              left: "1rem",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#7f8c8d",
            }}
          />
          <input
            type="text"
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "100%",
              padding: "0.75rem 1rem 0.75rem 3rem",
              border: "2px solid #e1e5e9",
              borderRadius: "5px",
              fontSize: "1rem",
            }}
          />
        </div>
      </div>

      {/* Users Table */}
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>User</th>
              <th>Role</th>
              <th>Status</th>
              <th>Last Login</th>
              <th>Total Calls</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <tr key={user.id}>
                <td>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "#3498db",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        marginRight: "1rem",
                        fontWeight: "bold",
                      }}
                    >
                      {user.name.charAt(0)}
                    </div>
                    <div>
                      <div style={{ fontWeight: "600", color: "#2c3e50" }}>
                        {user.name}
                      </div>
                      <div style={{ fontSize: "0.9rem", color: "#7f8c8d" }}>
                        {user.email}
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <span
                    style={{
                      padding: "0.25rem 0.75rem",
                      borderRadius: "15px",
                      fontSize: "0.8rem",
                      fontWeight: "500",
                      color: "white",
                      background: getRoleColor(user.role),
                    }}
                  >
                    {user.role}
                  </span>
                </td>
                <td>
                  <span
                    style={{
                      padding: "0.25rem 0.75rem",
                      borderRadius: "15px",
                      fontSize: "0.8rem",
                      fontWeight: "500",
                      color: "white",
                      background: getStatusColor(user.status),
                    }}
                  >
                    {user.status}
                  </span>
                </td>
                <td>{user.lastLogin}</td>
                <td>{user.calls}</td>
                <td>
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <button
                      className="btn"
                      style={{
                        padding: "0.5rem",
                        background: "#3498db",
                        color: "white",
                        border: "none",
                        borderRadius: "3px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleEditUser(user)}
                    >
                      <FiEdit />
                    </button>
                    <button
                      className="btn"
                      style={{
                        padding: "0.5rem",
                        background: "#e74c3c",
                        color: "white",
                        border: "none",
                        borderRadius: "3px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleDeleteUser(user.id)}
                    >
                      <FiTrash2 />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add User Modal */}
      {showAddModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div className="form-container" style={{ margin: "1rem" }}>
            <h2 style={{ marginBottom: "1.5rem", color: "#2c3e50" }}>
              Add New User
            </h2>
            <form onSubmit={handleAddUser}>
              <div className="form-group">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  className="form-input"
                  value={newUser.name}
                  onChange={(e) =>
                    setNewUser({ ...newUser, name: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-input"
                  value={newUser.email}
                  onChange={(e) =>
                    setNewUser({ ...newUser, email: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Role</label>
                  <select
                    className="form-input"
                    value={newUser.role}
                    onChange={(e) =>
                      setNewUser({ ...newUser, role: e.target.value })
                    }
                  >
                    <option value="User">User</option>
                    <option value="Moderator">Moderator</option>
                    <option value="Admin">Admin</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Status</label>
                  <select
                    className="form-input"
                    value={newUser.status}
                    onChange={(e) =>
                      setNewUser({ ...newUser, status: e.target.value })
                    }
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  type="button"
                  className="btn"
                  style={{ background: "#7f8c8d", color: "white" }}
                  onClick={() => setShowAddModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Add User
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Users;
